export const AUTH_TOKEN = 'veolia_auth_token';

export const cookiesSetting = { path: '/' };
